<template>
    <checkout-base
        :components="components"
        :scroll-top-offset="scrollTopOffset"
        :scroll-duration="scrollDuration"
    >
        <template slot-scope="{ currentStep }">
            <div class="cart">
                <cart v-if="currentStep < 3" />

                <checkout-steps
                    :components="components"
                    :scroll-top-offset="scrollTopOffset"
                    :scroll-duration="scrollDuration"
                    :current-step="currentStep"
                />
            </div>
        </template>
    </checkout-base>
</template>

<script>
export default {
    props: {
        scrollTopOffset: {
            type: Number,
            default: () => {
                return 150
            }
        },
        scrollDuration: {
            type: Number,
            default: () => {
                return 500
            }
        },
        components: {
            type: Array,
            default: () => {
                return [
                    'authentication',
                    'shipping-mode',
                    'payment-mode',
                    'customer-data',
                    'summary-step'
                ]
            }
        }
    },
}
</script>
